import { Button, Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const LoginModal = ({loginModal, setloginModal,propertyId='',message}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const login=()=>{
        let url='/login'
        if(propertyId) url=`/login?propertyId=${propertyId}`
        navigate(url)
    }

    const register=()=>{
        let url='/signup'
        if(propertyId) url=`/signup?propertyId=${propertyId}`
        navigate(url)
    }

    return (
        <>
            <Dialog
                open={loginModal}
                onClose={() => setloginModal(false)}
                className="relative z-[9999]"
            >
                <DialogBackdrop className="fixed inset-0 bg-black/30" />
                <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                    <DialogPanel className="max-w-md w-full bg-white rounded-[20px] mx-5">
                        <DialogTitle className="p-6">
                            <img src="/assets/img/question.png" alt="" className="w-[100px] mx-auto"/>
                            <p className="border-b text-[#389D93] text-[18px] text-center pb-5 mt-5">
                                {message || t('authentication.mustLoginFirst')}
                            </p>
                            {message ? (
                                <p className="text-center text-[13px] text-[#787878] mt-3">
                                    {t('authentication.freeAccount', "C'est gratuit et sans engagement.")}
                                </p>
                            ) : null}
                            <div className="pt-6 flex flex-col gap-3">
                                <Button
                                    onClick={()=>login()}
                                    className="w-full bg-[var(--brand,#976DD0)] text-white font-semibold py-2.5 px-6 rounded-[50px] hover:bg-[var(--brand-hover,#7D59B0)] transition-colors"
                                >
                                    {t('authentication.login')}
                                </Button>
                                <Button
                                    onClick={()=>register()}
                                    className="w-full border-2 border-[var(--brand,#976DD0)] text-[var(--brand,#976DD0)] font-semibold py-2.5 px-6 rounded-[50px] hover:bg-[var(--brand-pale,#F2ECF8)] transition-colors"
                                >
                                    {t('authentication.createAccount')}
                                </Button>
                                <Button
                                    onClick={()=>setloginModal(false)}
                                    className="w-full text-[#787878] font-medium py-2 px-6 rounded-[50px] hover:bg-gray-100 transition-colors"
                                >
                                    {t('buttons.later') || 'Plus tard'}
                                </Button>
                            </div>
                        </DialogTitle>
                    </DialogPanel>
                </div>
            </Dialog>
        </>
    )
}

export default LoginModal
